export default __webpack_public_path__ + "static/media/nba-selected.18e1a9e4.svg";